/**
 * Created by Jerker Nord on 2023-12-12.
 */
import {BasicBitmapCountUp} from "./BasicBitmapCountUp";
import {LonerGameAssets} from "../LonerGameAssets";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class LonerBitmapCountUp extends PIXI.Container {

    private static FLICKER_DELAY:number = 0.001;

    private _totalWinCountUp01:BasicBitmapCountUp;
    private _totalWinCountUp02:BasicBitmapCountUp;
    private _totalWinCountUp03:BasicBitmapCountUp;
    private _crtTL:gsap.core.Timeline;
    private _fontSize:number;
    private _maxWidth:number;

    constructor(fontSize:number, maxWidth:number = 720) {
        super();
        this._fontSize = fontSize;
        this._maxWidth = maxWidth;
        this.init();
    }

    private init():void {
        this._totalWinCountUp01 = new BasicBitmapCountUp({
            fontName : LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_01,
            fontSize : this._fontSize,
            tint : 0xffffff
        }, this._maxWidth, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp01.alpha = 0;
        this.addChild(this._totalWinCountUp01);

        this._totalWinCountUp02 = new BasicBitmapCountUp({
            fontName : LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_02,
            fontSize : this._fontSize,
            tint : 0xffffff
        }, this._maxWidth, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp02.alpha = 0;
        this.addChild(this._totalWinCountUp02);

        this._totalWinCountUp03 = new BasicBitmapCountUp({
            fontName : LonerGameAssets.BITMAP_FONT_WIN_COUNT_UP_03,
            fontSize : this._fontSize,
            tint : 0xffffff
        }, this._maxWidth, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp03.alpha = 0;
        this.addChild(this._totalWinCountUp03);

        this._crtTL = gsap.timeline({repeat : -1, paused : true});
        for(let i:number = 0; i < 10; i++) {
            this._crtTL.add(this.getFlickerTL());
        }
    }

    public preCalculateScale(from:number, to:number):void {
        this._totalWinCountUp01.preCalculateScale(from, to);
        this._totalWinCountUp02.preCalculateScale(from, to);
        this._totalWinCountUp03.preCalculateScale(from, to);
    }

    private getFlickerTL():gsap.core.Timeline {
        const flickerTL:gsap.core.Timeline = gsap.timeline();
        flickerTL.add(() => {
            this._totalWinCountUp01.alpha = 1;
            this._totalWinCountUp02.alpha = 0;
            this._totalWinCountUp03.alpha = 0;
        })
        flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.03, 0.06, 3)}));
        flickerTL.add(() => {
            this._totalWinCountUp01.alpha = 0;
            this._totalWinCountUp02.alpha = 1;
            this._totalWinCountUp03.alpha = 0;
        })
        flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.03, 0.06, 3)}));
        flickerTL.add(() => {
            this._totalWinCountUp01.alpha = 0;
            this._totalWinCountUp02.alpha = 0;
            this._totalWinCountUp03.alpha = 1;
        })
        flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.03, 0.06, 3)}));
        return flickerTL;
    }

    public startFlicker():void {
        if(this._crtTL.isActive() == false) {
            this._crtTL.restart();
        }
    }

    public stopFlicker():void {
        if(this._crtTL.isActive() == true) {
            this._crtTL.pause();
        }
    }

    public stopAt(amount:number):void {
        this._totalWinCountUp01.stopAt(amount);
        this._totalWinCountUp02.stopAt(amount);
        this._totalWinCountUp03.stopAt(amount);
    }

    public getCountAnimation(from:number, to:number, duration:number, countUpMultipliers:boolean = false):gsap.core.Timeline {
        return gsap.timeline().add([
            this._totalWinCountUp01.getCountAnimation(from, to, duration, countUpMultipliers),
            this._totalWinCountUp02.getCountAnimation(from, to, duration, countUpMultipliers),
            this._totalWinCountUp03.getCountAnimation(from, to, duration, countUpMultipliers),
        ]);
    }

    public forceSetText(newString:string):void {
        this._totalWinCountUp01.forceSetText(newString);
        this._totalWinCountUp02.forceSetText(newString);
        this._totalWinCountUp03.forceSetText(newString);
    }
}